export default __webpack_public_path__ + "static/media/Mark-3-HUD-Altitude Range.0593647d.jpg";